/**
 * Выбор раскладки по ширине окна (C6): от {@link DESKTOP_MIN_WIDTH} px — десктоп (поле по центру, колонки по бокам),
 * уже — телефонная раскладка, она не меняется. Порог тот же в CSS (`desktop.css`, media query) — тест следит.
 */
import { useEffect, useState } from "preact/hooks";

export const DESKTOP_MIN_WIDTH = 1024;

export type Layout = "phone" | "desktop";

export const DESKTOP_QUERY = `(min-width: ${DESKTOP_MIN_WIDTH}px)`;

export function pickLayout(width: number): Layout {
  return width >= DESKTOP_MIN_WIDTH ? "desktop" : "phone";
}

/**
 * Текущая раскладка; обновляется при смене ширины: `matchMedia` (основной наблюдатель порога) и `resize` (запасной —
 * окружения без `matchMedia`, повороты экрана).
 */
export function useLayout(): Layout {
  const [layout, setLayout] = useState<Layout>(() => pickLayout(window.innerWidth));
  useEffect(() => {
    const update = () => setLayout(pickLayout(window.innerWidth));
    const mq = typeof window.matchMedia === "function" ? window.matchMedia(DESKTOP_QUERY) : null;
    mq?.addEventListener("change", update);
    window.addEventListener("resize", update);
    update();
    return () => {
      mq?.removeEventListener("change", update);
      window.removeEventListener("resize", update);
    };
  }, []);
  return layout;
}
